import AuthGoogleButtonComponent from "./AuthGoogleButtonComponent";

export default AuthGoogleButtonComponent;
